import { forwardRef, type InputHTMLAttributes, type ReactNode, type SelectHTMLAttributes, type TextareaHTMLAttributes } from 'react';

/**
 * Site form controls (index.css `.site-*`). 48px tall, 16px text on phones, bronze focus ring, custom select chevron.
 *   <Field label="Email" hint="…" error={err}><Input type="email" /></Field>
 *   <Select pill>…</Select>   fully rounded, for search bars and filters
 */
export function Field({ label, hint, error, children, className = '' }: { label?: ReactNode; hint?: ReactNode; error?: ReactNode; children: ReactNode; className?: string }) {
  return (
    <label className={`site-field ${className}`}>
      {label && <span className="site-label">{label}</span>}
      {children}
      {error ? <span className="site-error">{error}</span> : hint ? <span className="site-hint">{hint}</span> : null}
    </label>
  );
}

type Shape = { pill?: boolean; compact?: boolean };
const shape = ({ pill, compact }: Shape) => `${pill ? 'is-pill' : ''} ${compact ? 'is-sm' : ''}`;

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement> & Shape>(function Input({ pill, compact, className = '', ...rest }, ref) {
  return <input ref={ref} className={`site-input ${shape({ pill, compact })} ${className}`} {...rest} />;
});

export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement> & Shape>(function Select({ pill, compact, className = '', children, ...rest }, ref) {
  return <select ref={ref} className={`site-select ${shape({ pill, compact })} ${className}`} {...rest}>{children}</select>;
});

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(function Textarea({ className = '', ...rest }, ref) {
  return <textarea ref={ref} className={`site-textarea ${className}`} {...rest} />;
});
